import React, { useState } from "react";
import {
  Box,
  Container,
  Typography,
  useTheme,
  alpha,
  Paper,
} from "@mui/material";
import { MilitaryTech } from "@mui/icons-material";
import Header from "../Components/Header";
import StudentSidebar from "./StudentSdebar";
import AchievementsCards from "../Components/AchievementsCards";

// Image Imports
import Sftm from "../Images/student_of_the_month.jpg";
import kudos from "../Images/Kudos.jpg";
import levelup from "../Images/Level_up.jpg";

const Achievements = () => {
  const theme = useTheme();
  const [sidebarExpanded, setSidebarExpanded] = useState(true);

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: '100vh', overflow: 'hidden', bgcolor: 'background.default' }}>
      <Header />
      <Box sx={{ display: 'flex', flexGrow: 1, overflow: 'hidden' }}>
        <StudentSidebar onToggle={setSidebarExpanded} />
        
        <Box 
          component="main" 
          sx={{ 
            flexGrow: 1, 
            p: { xs: 2, md: 4, lg: 6 },
            width: sidebarExpanded ? 'calc(100% - 260px)' : 'calc(100% - 80px)',
            transition: theme.transitions.create('width', { duration: 300 }),
            height: 'calc(100vh - 64px)',
            overflowY: 'auto'
          }}
        >
          <Container maxWidth="lg">
            {/* Header / Page Title Section */}
            <Box sx={{ mb: 8, textAlign: 'center' }}>
              <Box sx={{ 
                display: 'inline-flex', 
                alignItems: 'center', 
                gap: 2, 
                bgcolor: alpha('#D4AF37', 0.1), 
                px: 4, 
                py: 1.5, 
                borderRadius: '50px',
                border: '1px solid',
                borderColor: alpha('#D4AF37', 0.3),
                mb: 3
              }}>
                <MilitaryTech sx={{ color: '#D4AF37', fontSize: '2.5rem' }} />
                <Typography variant="h4" fontWeight={900} sx={{ 
                  color: '#D4AF37',
                  textTransform: 'uppercase',
                  letterSpacing: '2px'
                }}>
                  Hall of Fame
                </Typography>
              </Box>
              <Typography variant="h2" fontWeight={900} gutterBottom sx={{ 
                background: `linear-gradient(90deg, ${theme.palette.primary.main}, #D4AF37)`,
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
              }}>
                Your Achievements
              </Typography>
              <Typography variant="body1" color="text.secondary" sx={{ maxWidth: '700px', mx: 'auto', fontSize: '1.1rem' }}>
                Celebrate your milestones! Every badge earned is a step towards mastering your craft. Keep pushing the boundaries of what you can learn.
              </Typography>
            </Box>

            {/* Achievements Grid */}
            <Box sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', gap: 6, py: 4 }}>
              <AchievementsCards
                img={Sftm}
                title={"Student of the Month"}
                date={"18th Sept 2024"}
              />
              <AchievementsCards
                img={kudos}
                title={"Kudos!!"}
                date={"25th Sept 2024"}
              />
              <AchievementsCards
                img={levelup}
                title={"Level Up"}
                date={"7th Oct 2024"}
              />
            </Box>

            {/* Stats section could be added here in the future */}
            <Paper elevation={0} sx={{ 
              mt: 10, 
              p: 4, 
              borderRadius: '30px', 
              textAlign: 'center',
              border: '1px dashed',
              borderColor: 'divider',
              bgcolor: alpha(theme.palette.primary.main, 0.02)
            }}>
              <Typography variant="h6" fontWeight={700} gutterBottom>Ready for the next challenge?</Typography>
              <Typography variant="body2" color="text.secondary">Complete more modules and participate in the community to unlock hidden achievements!</Typography>
            </Paper>
          </Container>
        </Box>
      </Box>
    </Box>
  );
};

export default Achievements;
